// Custom Turbo Stream action to open a modal
import { StreamActions } from "@hotwired/turbo"

StreamActions.modal_open = function() {
  const modalId = this.getAttribute("target")

  // Try to find the modal element - it might be a wrapper div with the ID
  // or the dialog element itself
  const modalWrapper = document.getElementById(modalId)

  if (modalWrapper) {
    // Dispatch a custom event to open the modal (picked up by modal_controller.js)
    modalWrapper.dispatchEvent(new CustomEvent("modal:open"))

    // Also try to find and show the dialog directly
    const dialog = modalWrapper.querySelector("dialog") || modalWrapper
    if (dialog && dialog.tagName === "DIALOG" && !dialog.open) {
      dialog.showModal()
    }
  }
}
